import {
  financialFetch,
  financialPost,
  financialPut,
  financialDelete,
} from "../../../Component/function/FinancialApi";

const ENDPOINT = "SupplierTransaction";

const buildQueryUrl = (base, params = {}) => {
  const cleaned = {};

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined
    ) {
      cleaned[key] = value;
    }
  });

  const query = new URLSearchParams(cleaned).toString();

  return query ? `${base}?${query}` : base;
};

const supplierTransactionService = {
  getAll: async (params = {}) => {
    return await financialFetch(
      buildQueryUrl(ENDPOINT, params)
    );
  },

  getById: async (id) => {
    return await financialFetch(
      `${ENDPOINT}/${id}`
    );
  },

  getBalances: async () => {
    return await financialFetch(
      `${ENDPOINT}/balances`
    );
  },

  create: async (payload) => {
    const response = await financialPost(
      ENDPOINT,
      payload
    );

    return response?.data;
  },

  update: async (id, payload) => {
    const response = await financialPut(
      `${ENDPOINT}/${id}`,
      payload
    );

    return response?.data;
  },

  remove: async (id) => {
    const response = await financialDelete(
      `${ENDPOINT}/${id}`
    );

    return response?.data;
  },
};

export default supplierTransactionService;